import Cookies from 'js-cookie';
export const KEY_ACCESS_TOKEN = 'access_token';
export const CURRENT_USER_TYPE = 'userType';
export const VISIBLE_STRENGTH = 'visibleStrength';
export const VISIBLE_WEAKNESSES = 'visibleWeakness';
export const VISIBLE_VALUES = 'visiblePersonalValues';
export const VISIBLE_MOTIVATES_YOU = 'visibleMotiavate';
export const VISIBLE_DISC = 'visibleStrength';
export const VISIBLE_GOALS = 'visibleGoals';

const cookieOptions = {
  expires: 30,
  secure: process.env.NODE_ENV === 'production',
  sameSite: 'strict',
  path: '/',
};

export function getItem(key) {
  return Cookies.get(key);
}

export function setItem(key, value) {
  return Cookies.set(key, value, cookieOptions);
}

export function removeItem(key) {
  return Cookies.remove(key, { path: '/' });
}

export const isUserAuthenticated = () => {
  const token = getItem(KEY_ACCESS_TOKEN);
  return !!token;
};

export const getCurrentUser = () => {
  return getItem(CURRENT_USER_TYPE);
};

export const setUser = (user) => {
  setItem(CURRENT_USER_TYPE, user);
};
// App-specific cookie keys that should be cleared on logout
const APP_COOKIE_KEYS = [
  KEY_ACCESS_TOKEN,
  CURRENT_USER_TYPE,
  VISIBLE_STRENGTH,
  VISIBLE_WEAKNESSES,
  VISIBLE_VALUES,
  VISIBLE_MOTIVATES_YOU,
  VISIBLE_DISC,
  VISIBLE_GOALS,
];

export const logoutUser = () => {
  // Only remove app-specific cookies — do not clear all cookies indiscriminately
  APP_COOKIE_KEYS.forEach((key) => removeItem(key));
};

// Re-set the access token cookie to refresh its expiry and mark session as active
export const markSessionActive = () => {
  const token = getItem(KEY_ACCESS_TOKEN);
  if (token) {
    setItem(KEY_ACCESS_TOKEN, token);
  }
};
